import { data_from_server_post } from '@/shared/http/client';
import { TaskType } from '@/shared/domain/taskTypes';
export async function fetchSummarizationEvaluation({
  client_id,
  llm_usecase_id,
  version,
  comparison_mode = false,
  compare_with_version = null,
  compare_with_file = false,
  selected_distillation_event_id = null,
  task_type = TaskType.summarization,
}) {
  return await data_from_server_post('evaluation', {
    client_id,
    llm_usecase_id,
    version,
    comparison_mode,
    compare_with_version,
    compare_with_file,
    sub_task_type: null,
    task_type: task_type || TaskType.summarization,
    selected_distillation_event_id: selected_distillation_event_id || null,
  });
}

export async function fetchLlmUsecaseInfo({ client_id, llm_usecase_id }) {
  return await data_from_server_post('llm_usecase_info', {
    client_id,
    llm_usecase_id,
  });
}

export async function updateLlmJudgeConfig({
  client_id,
  usecase_id,
  user_criteria_prompts,
  llm_judge_enabled_by_id,
  classic_metrics_config,
}) {
  return await data_from_server_post('update_llm_judge_config', {
    client_id,
    usecase_id,
    user_criteria_prompts,
    llm_judge_enabled_by_id,
    classic_metrics_config,
  });
}

export async function fetchSummarizationSamples({
  client_id,
  llm_usecase_id,
  version,
  comparison_version = null,
  is_version_comparison = false,
  is_file_comparison = false,
  page,
  page_size,
  search = '',
  language = null,
  primary_model = 'student',
  selected_distillation_event_id = null,
}) {
  return await data_from_server_post('model-responses', {
    client_id,
    llm_usecase_id,
    version,
    page,
    page_size,
    filters: {
      search: search || '',
      language: language || null,
    },
    comparison_version,
    primary_model,
    is_version_comparison,
    is_file_comparison,
    sub_task_type: null,
    selected_distillation_event_id: selected_distillation_event_id || null,
  });
}

